import { rootApi } from '../rootApi';

export const dealerStockAddApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyAddedStockLogs: builder.query({
            query: (params) => ({
                url: 'v1/dealerstock/my-added-stock-logs',
                params: {
                    PageNumber: params?.PageNumber ?? 1,
                    PageSize: params?.PageSize ?? 10,
                    DateFrom: params?.DateFrom || '',
                    DateTo: params?.DateTo || ''
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? response.data.items.length
                    };
                }
                if (response?.data && Array.isArray(response.data)) {
                    return {
                        items: response.data,
                        totalCount: response.totalCount ?? response.data.length
                    };
                }
                if (Array.isArray(response)) {
                    return { items: response, totalCount: response.length };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['DealerStockAdd']
        }),

        getDealerStockDealerDropdown: builder.query({
            query: (params) => ({
                url: 'v1/dealerstock/dealer-dropdown',
                params: {
                    SearchText: params?.SearchText || ' ',
                    PageNumber: params?.PageNumber ?? 1,
                    PageSize: params?.PageSize ?? 50
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data)) return response.data;
                if (Array.isArray(response)) return response;
                return [];
            }
        }),

        getDealerStockWarehouseDropdown: builder.query({
            query: (params) => ({
                url: 'v1/dealerstock/warehouse-dropdown',
                params: {
                    DealerId: params?.DealerId
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data)) return response.data;
                if (Array.isArray(response)) return response;
                return [];
            }
        }),

        getDealerStockPartDropdown: builder.query({
            query: (params) => ({
                url: 'v1/dealerstock/part-dropdown',
                params: {
                    DealerId: params?.DealerId,
                    WareHouseId: params?.WareHouseId,
                    SearchText: params?.SearchText || ' ',
                    PageNumber: params?.PageNumber ?? 1,
                    PageSize: params?.PageSize ?? 50
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data)) return response.data;
                if (Array.isArray(response)) return response;
                return [];
            }
        }),

        addDealerStock: builder.mutation({
            query: (data) => ({
                url: 'v1/dealerstock/add-stock',
                method: 'POST',
                body: {
                    partCode: data.partCode,
                    wareHouseId: data.wareHouseId,
                    dealerId: data.dealerId,
                    quantity: data.quantity
                }
            }),
            invalidatesTags: ['DealerStockAdd']
        })
    })
});

export const {
    useGetMyAddedStockLogsQuery,
    useGetDealerStockDealerDropdownQuery,
    useLazyGetDealerStockDealerDropdownQuery,
    useGetDealerStockWarehouseDropdownQuery,
    useLazyGetDealerStockWarehouseDropdownQuery,
    useGetDealerStockPartDropdownQuery,
    useLazyGetDealerStockPartDropdownQuery,
    useAddDealerStockMutation
} = dealerStockAddApi;
